import { supabase } from "@/integrations/supabase/client";
import { Analytics, resetUser } from "@/lib/analytics";

export async function signOutUser(): Promise<{ error: Error | null }> {
  Analytics.signOut();
  resetUser();
  const { error } = await supabase.auth.signOut();
  return { error: error ?? null };
}
